import LegalLayout from "@/components/LegalLayout";

export default function Disclaimer() {
    return (
        <LegalLayout testId="disclaimer-page" title="Disclaimer">
            <p>
                Welcome to FilesCAD — your destination for digital files tailored for CNC cutting, engraving, and more. We prioritize providing high-quality content while being mindful of various sensitivities and values. Please note the following.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">1. Intellectual Property Rights</h3>
            <p>
                We respect intellectual property rights and expect our users to do the same. Users are responsible for ensuring they have the necessary rights to use, modify, and distribute files obtained from our platform.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">2. Content Accuracy</h3>
            <p>
                While we strive for accuracy and quality, we cannot guarantee the suitability, completeness, or accuracy of any files. Users are encouraged to verify the suitability of files for their intended purposes before use.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">3. User Responsibility</h3>
            <p>
                Users are solely responsible for their use of files from FilesCAD. We disclaim any liability for damages, losses, or injuries arising from platform use or file utilization.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">4. Sensitive Content</h3>
            <p>
                While we aim to avoid offending sentiments or beliefs, interpretations of content may vary. FilesCAD does not endorse offensive, discriminatory, or inappropriate content.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">5. Third-party Content</h3>
            <p>
                FilesCAD may contain links to third-party websites or content. We do not endorse or assume responsibility for the accuracy, legality, or content of these third-party sites.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">6. Changes to Disclaimer</h3>
            <p>
                FilesCAD reserves the right to modify this disclaimer at any time without prior notice. Users are encouraged to review it periodically.
            </p>

            <p className="mt-10">
                By using FilesCAD, you agree to these disclaimers. If you disagree with any part, please refrain from using our platform. For inquiries, contact us at{" "}
                <a
                    href="mailto:support@filescad.com"
                    data-testid="disclaimer-contact-email"
                    className="text-blue-600 hover:underline font-semibold"
                >
                    support@filescad.com
                </a>
                .
            </p>
        </LegalLayout>
    );
}
